// Constants
import { branchNames } from '@src/common/constants/ab';

export const getNameBranch = (index: number): string => branchNames[index];
